import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { useIsMobile } from '../ProjectLocation/helpers';

function DeleteRoomModal(props) {

  const {
    title,
    bodyText,
    onConfirmation,
    onDismiss,
    showModal,
    roonName,
  } = props;

  const isMobile = useIsMobile();

  return (
    <>
      <Modal size="sm" open={showModal} onClose={onDismiss} id={title}>
        <ModalHeader onClose={onDismiss}>
          <Typography variant="h4" weight="bold" style={{ marginBottom: '1.6rem' }}> {title} </Typography>
        </ModalHeader>
        <ModalBody>
          <Typography>
            <span>{bodyText}</span>
            <span style={{ fontWeight: 'bold' }}> {roonName}</span>
            <span>?</span>
          </Typography>
        </ModalBody>
        <ModalFooter position="end">
          <ButtonGroup
            orientation={isMobile ? 'vertical' : 'horizontal'}
            variant={isMobile ? 'primary' : 'secondary'}
          >
            <Button variant="secondary" style={{ display: isMobile && 'none' }} onClick={onDismiss}>Cancel
            </Button>
            <Button variant="primary" onClick={onConfirmation}>Delete Room</Button>
            <Button variant="secondary" style={{ display: !isMobile && 'none' }} onClick={onDismiss}>Cancel
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    </>
  );
}

DeleteRoomModal.propTypes = {
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  roonName: PropTypes.string.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
};

DeleteRoomModal.defaultProps = {
  showModal: false,
};

export default DeleteRoomModal;